import PropTypes from 'prop-types'
import AddIcon from '@mui/icons-material/Add'
import {
  CategoryHeaderContainer,
  CategoryTitleWrapper,
  CategoryTitle,
  StyledCategoryCountChip,
  StyledCategoryAddButton
} from './CategoryHeaderStyles'

/**
 * CategoryHeader Component
 *
 * Displays the category title with a selected count chip and an Add button.
 *
 * @param {Object} props
 * @param {string} props.title - Category title
 * @param {number} props.selectedCount - Number of selected filters
 * @param {Function} props.onAddClick - Callback when Add button is clicked
 * @param {React.Ref} props.buttonRef - Ref for the Add button
 * @param {boolean} props.isOpen - Whether the category popover is open
 */
const CategoryHeader = ({title, selectedCount = 0, onAddClick, buttonRef, isOpen = false}) => {
  return (
    <CategoryHeaderContainer>
      <CategoryTitleWrapper>
        <CategoryTitle>
          {title}
          {selectedCount > 0 && <StyledCategoryCountChip size='small' label={selectedCount} color='primary' />}
        </CategoryTitle>
      </CategoryTitleWrapper>
      <StyledCategoryAddButton
        ref={buttonRef}
        size='small'
        startIcon={<AddIcon />}
        onClick={onAddClick}
        aria-label={`Add filter for ${title}`}
        isOpen={isOpen}
      >
        Add
      </StyledCategoryAddButton>
    </CategoryHeaderContainer>
  )
}

CategoryHeader.propTypes = {
  title: PropTypes.string.isRequired,
  selectedCount: PropTypes.number,
  onAddClick: PropTypes.func.isRequired,
  buttonRef: PropTypes.object,
  isOpen: PropTypes.bool
}

export default CategoryHeader
